module.exports = __webpack_public_path__ + "static/img/cartime.816165d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartime.png
// module id = cbBK
// module chunks = 0